<template lang="html">
  <div class="script">
    <div class="script-name">
      <div style="padding: 4px;display: inline-block;">
        <i class="icon-code"></i>
        <span>&nbsp;{{script.name}}</span>
      </div>
      <button type="button" class="btn-icon btn-delete" title="Remove Script" style="float: right;font-size: inherit;margin: 0;" @click="$emit('delete')">
        <i class="icon-delete"></i>
      </button>
    </div>
    <div class="script-properties">
      <div v-for="(placeholder, index) in placeholders" :key="index" style="font-size: 14px;padding: 5px;">
        <label style="margin: 0;color: inherit;background: none;display: block;padding: 6px 0;">{{placeholder.label}}</label>
        <input v-if="placeholder.type === 'text'" type="text" :value="getVariableValue(placeholder, index)" @change="setVariableValue(index, $event.target.value)" />
        <input v-if="placeholder.type === 'checkbox'" type="checkbox" :checked="getVariableValue(placeholder, index)" @change="setVariableValue(index, $event.target.checked)" />
        <select v-if="placeholder.type === 'select'" :value="getVariableValue(placeholder, index)" @change="setVariableValue(index, $event.target.value)">
          <option v-for="option in placeholder.options" :key="option">{{option}}</option>
        </select>
        <select v-if="placeholder.type === 'file'" :value="getVariableValue(placeholder, index)" @change="setVariableValue(index, $event.target.value)">
          <option v-for="file in getFilesWithExtensions(placeholder.extensions)" :key="file.id">{{file.name}}</option>
        </select>
      </div>
    </div>
  </div>
</template>

<script>
import GameStudio from '@/assets/js/GameStudio.js'
const UtilEditor = window.UtilEditor;

export default {
  props: ['scriptRef'],
  data() {
    return {
      script: GameStudio.getFileById(this.scriptRef.id)
    };
  },
  computed: {
    placeholders() {
      return UtilEditor.getScriptVarPlaceholders(this.script);
    }
  },
  methods: {
    getVariableValue(placeholder, index) {
      let value = (this.scriptRef.data[index] == null) ? placeholder.defaultValue : this.scriptRef.data[index];
      if (placeholder.type === 'checkbox') {
        value = eval(value);
      }
      return value;
    },
    setVariableValue(index, newValue) {
      this.scriptRef.data[index] = newValue;
    },
    getFilesWithExtensions(extensions) {
      return GameStudio.getFilesWithExtensions(extensions);
    }
  },
  mounted() {
    this.placeholders.forEach((variable, index) => {
      this.scriptRef.data[index] = (this.scriptRef.data[index] == null) ? null : this.scriptRef.data[index];
    });
  }
}
</script>

<style lang="css" scoped>
</style>
